import React, { createContext, useState, useEffect } from 'react';
import styled from "styled-components";
import IconWithBackground from "new_components/molecules/IconWithBackground";
import Icon from "new_components/atoms/Icon";
import SelectCard from "new_components/organisms/SelectCard";
import { ICON_SET } from "new_components/atoms/Icon/IconSet";
import colors from "styles/colors";

const Home = ({setWorkflow}) => {

    return (
      <Container>
        <Title>Workflow AI</Title>

        <Description>
          Use AI to guide you through your data. Go from data to insights in
          minutes using one of our expert built, AI guided workflows.
        </Description>

        <CardContainer>
          <SelectCard
            iconName={ICON_SET.question}
            iconBgColor={colors.primary[50]}
            title="Risk Assessment"
            description="Analyze where groups of lower scores are present, and identify the key factors that are driving the risk."
            onClick={() => setWorkflow("risk")}
            noFooter
          />

          <SelectCard
            iconName={ICON_SET.lightning}
            iconBgColor={colors.primary[50]}
            title="ROI Analysis"
            description="See what factors are driving your outcomes using advanced regression analysis."
            onClick={() => setWorkflow("roi")}
            noFooter
          />

          <SelectCard
            iconName={ICON_SET.layers}
            iconBgColor={colors.primary[50]}
            title="Thematic Analysis"
            description="Generate insights from your data by identifying the key themes using the most advanced AI models."
            onClick={() => setWorkflow("thematic")}
            noFooter
          />

          <SelectCard
            iconName={ICON_SET.adaptability}
            iconBgColor={colors.primary[50]}
            title="Change Analysis"
            description="Discover the key changes in your data based using AI and quantitative analytics."
            onClick={() => setWorkflow("change")}
            noFooter
          />
        </CardContainer>
      </Container>
    );
}

export default Home;

const Container = styled.div`
    display:flex;
    flex-direction: column;
    width:100%;
    font-family: 'Raleway', sans-serif;
    margin-top:20px;
    padding:20px;
`

const Title = styled.div`
    font-size:24px;
    font-weight:bold;
    margin-bottom:10px;
`

const Description = styled.div`
    margin-bottom:20px;
    max-width:700px;
`

const CardContainer = styled.div`
    display:flex;
    width:100%;
    flex-wrap:wrap;
`

const Card = styled.div`
    width: calc(33% - 20px);
    background-color: #F8FAFF;
    border-radius:5px;
    padding:20px;
    margin-right:20px;
    margin-bottom:20px;
    cursor:pointer;

    &:hover{
    background-color:#EBF1FD;
    }
`

const CardTitile = styled.div`
    color:#2A3039;
    font-size:16px;
    font-weight:600;
    margin-bottom:10px;
    margin-top:20px;
`
const CardDescription = styled.div`
    color:#706C85;
    font-size:12px;
    min-height:75px;
`

const Action = styled.div`
    color:#2D70E2;
    font-size:14px;
    font-weight:600;
    display:flex;
    align-items:center;
    margin-top:20px;
`